import React, { useState, useEffect, useMemo } from 'react';
import {
  Col,
  Form,
  Modal,
  Row,
  Button,
  Image,
  Accordion
} from 'react-bootstrap';
import icTitle from '../../../assets/images/ic-gift.svg';
import EditIcon from '../../../assets/images/ic-edit.svg';
import ENGModalBody from '../../../components/modal/ENGModalBody';
import ENGModalHeader from '../../../components/modal/ENGModalHeader';
import '../Help.css';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  AddMyDeclarationAsync,
  EditMyDeclarationAsync,
  selectAddMyDeclaration,
  selectDeclarationTypeList,
  selectEditMyDeclaration,
  GetUserDetailsAsync,
  selectUserDetails,
  selectLoadingState,
  getDeclarationApprovalDownloadAsync
} from '../../../features/helpandassistance/DeclarationSlice';
import FileUpload from '../../../components/textField/FileUpload';
import swal from 'sweetalert';
import COIAccordionAction from '../../learning/accordion/COIAccordionAction';
import ConflictTypeCard from './ConflictTypeCard';
import { selectCoiSectorList } from '../../../features/helpandassistance/SectorListSLice';
import { getDeclarationApprovalDownloadAPI } from '../../../features/helpandassistance/DeclarationAPI';

const declarationType = [
  {
    label: 'Actual',
    content:
      'An existing direct conflict between professional and personal interest'
  },
  {
    label: 'Potential',
    content:
      'Any change in current circumstance which leads to a direct conflict of interest'
  },
  {
    label: 'Perceived',
    content: 'Any situation which may appear to conflicted'
  }
];

const DeclarationFormNew = ({
  isEdit,
  editData
}: {
  isEdit: boolean;
  editData?: any;
}) => {
  const dispatch = useAppDispatch();

  const declarationCategory = useAppSelector(selectDeclarationTypeList);
  const addDeclaration = useAppSelector(selectAddMyDeclaration);
  const editDeclaration = useAppSelector(selectEditMyDeclaration);
  const userDetails = useAppSelector(selectUserDetails);
  const isLoading = useAppSelector(selectLoadingState);
  const sectorList = useAppSelector(selectCoiSectorList);

  const [modalShow, setModalShow] = useState(false);
  const [Matter, setMatter] = useState('');
  // const [Type, setType] = useState<string>('');
  const [Category, setCategory] = useState<string>('');
  const [file1, setFile1] = useState('');
  const [file2, setFile2] = useState('');
  const [IsAPI, setIsAPI] = useState(false);
  const [IsTerms, setIsTerms] = useState(false);
  const [sector, setSector] = useState<string>('');

  useEffect(() => {
    dispatch(GetUserDetailsAsync());
  }, []);

  useEffect(() => {
    if (editData && isEdit && modalShow) {
      setMatter(editData?.perticularMatter);
      // setType(editData?.declearationCategoryType);
      setCategory(editData?.conflictCategoryMasterId);
      setSector(editData?.coiSectorId);
      let files = editData?.fileName ? editData?.fileName.split(',') : [];
      setFile1(files.length > 0 ? files[0] : '');
      setFile2(files.length > 1 ? files[1] : '');
    } else if (!isEdit) {
      const matterdata = localStorage.getItem('matter');
      const typedata = localStorage.getItem('conflictType');
      const categorydata = localStorage.getItem('category');
      const file1data = localStorage.getItem('file1');
      const file2data = localStorage.getItem('file2');
      const istermsdata = localStorage.getItem('isTerms');
      const coiSector = localStorage.getItem('coiSector');
      setMatter(matterdata ? matterdata : '');
      // setType(typedata ? typedata : '');
      setCategory(categorydata ? categorydata : '');
      setFile1(file1data ? file1data : '');
      setFile2(file2data ? file2data : '');
      setIsTerms(istermsdata === 'true' ? true : false);
      setSector(coiSector ? coiSector : '');
    }
  }, [editData, modalShow]);

  useEffect(() => {
    if (IsAPI && addDeclaration) {
      setIsAPI(false);
      handleClose();
      handleClearLocalData();
      swal({
        title: 'Success',
        text: 'Conflict of Interest Submitted Successfully.',
        icon: 'success',
        dangerMode: true,
        timer: 3000,
        buttons: {
          cancel: false,
          confirm: false
        }
      });
    }
  }, [addDeclaration]);

  useEffect(() => {
    if (IsAPI && editDeclaration) {
      setIsAPI(false);
      handleClose();
      handleClearLocalData();
      swal({
        title: 'Success',
        text: 'Conflict of Interest Updated Successfully.',
        icon: 'success',
        dangerMode: true,
        timer: 3000,
        buttons: {
          cancel: false,
          confirm: false
        }
      });
    }
  }, [editDeclaration]);

  const handleClearLocalData = () => {
    localStorage.removeItem('matter');
    localStorage.removeItem('conflictType');
    localStorage.removeItem('category');
    localStorage.removeItem('file1');
    localStorage.removeItem('file2');
    localStorage.removeItem('isTerms');
    localStorage.removeItem('coiSector');
  };

  const handleClose = () => {
    setMatter('');
    // setType('');
    setCategory('');
    setFile1('');
    setFile2('');
    setModalShow(false);
    setIsTerms(false);
    setSector('');
  };
  const handleShow = () => setModalShow(true);

  const IsValid = useMemo(() => {
    // const isValid = !!Type && !!Category && !!IsTerms && !!sector;
    const isValid = !!Category && !!IsTerms && !!sector;
    return isValid;
  }, [Category, IsTerms, sector]);

  const onSubmits = async (event: any) => {
    event.preventDefault();

    swal({
      title: 'Are you sure?',
      text: 'Are you sure that you want to submit?',
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: true,
        confirm: true
      }
    }).then(async (willSubmit) => {
      if (willSubmit) {
        let fileList = [];
        if (!!file1) {
          fileList.push(file1);
        }
        if (!!file2) {
          fileList.push(file2);
        }
        let data = {
          perticularMatter: Matter,
          declearationCategoryType: '',
          conflictCategoryMasterId: Category,
          coiSectorId: sector,
          fileName: fileList.join(',')
        };
        // console.log("===== Form Data =====>", data);
        if (IsValid) {
          setIsAPI(true);
          if (isEdit) {
            await dispatch(
              EditMyDeclarationAsync({ ...data, id: editData?.id })
            );
          } else {
            await dispatch(AddMyDeclarationAsync(data));
          }
        }
      }
    });
  };

  // function conflictTypeContent() {
  //   return (
  //     <Row>
  //       <Col xs={12} sm={12} className='pb-3 pt-2'>
  //         <Row className='conflictType'>
  //           {declarationType.length > 0 &&
  //             declarationType.map((val: any) => (
  //               <Col xs={12} sm={4} className='py-1 px-2'>
  //                 <Form.Check
  //                   inline
  //                   type='radio'
  //                   onChange={(e: any) => {
  //                     setType(e.target.value);
  //                     {
  //                       !isEdit &&
  //                         localStorage.setItem('conflictType', e.target.value);
  //                     }
  //                   }}
  //                   name='type'
  //                   className='terms'
  //                   checked={Type === val?.label}
  //                   value={val?.label}
  //                   label={
  //                     <ConflictTypeCard
  //                       title={val?.label}
  //                       content={val?.content}
  //                     />
  //                   }
  //                 />
  //               </Col>
  //             ))}
  //         </Row>
  //       </Col>
  //     </Row>
  //   );
  // }

  function coiCategoryContent() {
    return (
      <Row>
        <Col xs={12} sm={12} className='pb-3 pt-2'>
          {declarationCategory.length > 0 &&
            declarationCategory.map((val: any) => (
              <Form.Check
                type='radio'
                onChange={(e: any) => {
                  setCategory(e.target.value);
                  {
                    !isEdit && localStorage.setItem('category', e.target.value);
                  }
                }}
                name='category'
                className='terms'
                checked={Category == val?.id}
                value={val?.id}
                label={val?.title}
              />
            ))}
        </Col>
      </Row>
    );
  }

  function circumstancesContent() {
    return (
      <Row>
        <Col sm={12} xs={12} className='pb-3 pt-2'>
          <Form.Control
            className='shadow-none'
            style={styles.text1}
            as='textarea'
            rows={2}
            placeholder='Describe the circumstances giving rise to the conflict'
            id='Matter'
            value={Matter}
            maxLength={1000}
            onChange={(e: any) => {
              setMatter(e.target.value);
              {
                !isEdit && localStorage.setItem('matter', e.target.value);
              }
            }}
          />
          <Row>
            <Col xs='auto' className='ms-auto'>
              {1000 - Matter?.length} remaining
            </Col>
          </Row>
        </Col>
        <Col xs={12} sm={6} className='pb-3 pt-2'>
          <FileUpload
            setFile={(e: any) => {
              setFile1(e);
              {
                !isEdit && localStorage.setItem('file1', e);
              }
            }}
            title='Attachment 1 (optional)'
            fileValue={file1}
            fileType='other'
            accept='.doc,.docx,.pdf,.jpg,.jpeg,.txt,.svg'
            isRequired={false}
          />
        </Col>
        <Col xs={12} sm={6} className='pb-3 pt-2'>
          <FileUpload
            setFile={(e: any) => {
              setFile2(e);
              {
                !isEdit && localStorage.setItem('file2', e);
              }
            }}
            title='Attachment 2 (optional)'
            fileValue={file2}
            fileType='other'
            accept='.doc,.docx,.pdf,.jpg,.jpeg,.txt,.svg'
            isRequired={false}
          />
        </Col>
      </Row>
    );
  }

  function acknowledgeContent() {
    return (
      <Row>
        <Col xs={12} className='pb-3 pt-2'>
          <Form.Check
            type='checkbox'
            onChange={(e: any) => {
              setIsTerms(e.target.checked);
              {
                !isEdit && localStorage.setItem('isTerms', e.target.checked);
              }
            }}
            id='terms'
            checked={!!IsTerms}
            className='terms'
            label='I acknowledge, that this declaration has been made to the best of my knowledge with consent and in compliance with Mahindra’s policies. Further, I have no other actual, potential or perceived conflict of interest declarations to be made.*'
          />
        </Col>
      </Row>
    );
  }

  function sectorContent() {
    return (
      <Row>
        <Col xs={12} sm={6} className='pb-3 pt-2'>
          <select
            id='declare'
            onChange={(e: any) => {
              setSector(e.target.value);
              {
                !isEdit && localStorage.setItem('coiSector', e.target.value);
              }
            }}
            value={sector}
            className='shadow-none d-inline-block'
            style={{
              backgroundColor: 'white',
              border: 'solid 1px #e4e4e4',
              borderRadius: '0px',
              width: '100%',
              fontFamily: 'Saira',
              fontSize: '16px',
              color: '#6d6e71'
            }}
            required
          >
            <option value=''>Select Sector</option>
            {sectorList?.length > 0 &&
              sectorList.map((val: any) => (
                <option value={val.id}>{val.sectorName}</option>
              ))}
          </select>
        </Col>
      </Row>
    );
  }

  const Show = (label: string, value: any, sm: number = 4) => {
    return (
      <Col xs={12} sm={sm} className='mt-2'>
        <div style={styles.label}>{label}</div>
        <div style={styles.value}>{value ? value : '-'}</div>
      </Col>
    );
  };

  return (
    <>
      {isEdit ? (
        <a
          onClick={handleShow}
          href='#'
          style={{
            backgroundColor: '#fff',
            color: '#e31837',
            fontWeight: 600,
            fontSize: '12px'
          }}
        >
          <Image src={EditIcon} />
        </a>
      ) : (
        <div className='d-flex justify-content-end '>
          <button
            className='button'
            onClick={handleShow}
            style={{
              padding: '10px 15px',
              fontFamily: 'Saira',
              fontSize: '12px',
              fontWeight: 500,
              fontStretch: 'normal',
              fontStyle: 'normal'
            }}
          >
            RAISE A CONFLICT{' '}
          </button>
        </div>
      )}

      <Modal
        show={modalShow}
        onHide={handleClose}
        backdrop='static'
        size='lg'
        keyboard={false}
      >
        <Form onSubmit={onSubmits}>
          <ENGModalHeader
            icon={icTitle}
            title={editData ? 'Edit A CONFLICT' : 'RAISE A CONFLICT'}
          />
          <ENGModalBody
            contents={
              <>
                <Row className='px-4 pt-2 pb-3'>
                  {Show('Name', userDetails?.name)}
                  {Show('Token No.', userDetails?.employeeId)}
                  {Show('Designation', userDetails?.designation)}
                  {/* {Show("Department", userDetails?.departmentName)} */}
                  {Show('Location', userDetails?.location)}
                  {Show('Line Manager', userDetails?.lineManagerName)}
                </Row>
                <Accordion defaultActiveKey='0'>
                  <COIAccordionAction
                    title='1. Select your sector*'
                    isCompleted={!!sector}
                    content={sectorContent()}
                    eventKey='0'
                  />
                  {/* <COIAccordionAction
                    title='2. Select a Conflict Type*'
                    isCompleted={!!Type}
                    content={conflictTypeContent()}
                    eventKey='1'
                  /> */}
                  <COIAccordionAction
                    title='2. Select the Conflict of Interest scenario*'
                    isCompleted={!!Category}
                    content={coiCategoryContent()}
                    eventKey='1'
                  />
                  <COIAccordionAction
                    title='3. Provide further details on the selected Conflict of Interest scenario'
                    isCompleted={!!Matter || !!file1 || !!file2}
                    content={circumstancesContent()}
                    eventKey='2'
                  />
                  <COIAccordionAction
                    title='4. Acknowledgement*'
                    isCompleted={!!IsTerms}
                    content={acknowledgeContent()}
                    eventKey='3'
                  />
                </Accordion>
              </>
            }
          />
          <Modal.Footer style={styles.bgGrey}>
            <Button
              type='submit'
              style={styles.button}
              disabled={isLoading || !IsValid || !IsTerms}
            >
              SUBMIT
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

const styles: any = {
  text1: {
    fontFamily: 'Saira',
    fontSize: '16px',
    color: '#6d6e71',
    border: 'solid 1px #e4e4e4',
    borderRadius: '0px'
  },
  bgGrey: {
    backgroundColor: '#faf9f9'
  },
  button: {
    padding: '13px 40px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    border: '0px',
    color: '#fff'
  },
  label: {
    fontFamily: 'Saira',
    fontSize: '14px',
    fontWeight: '600',
    fontStrech: 'normal',
    textAlign: 'left'
  },
  value: {
    fontFamily: 'Saira',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStrech: 'normal',
    textAlign: 'left'
  }
};

export default DeclarationFormNew;
